export const catchError = (error, errorRef) => {
	console.log(error)
	const errorMessages = error?.response?.data?.errors
		? Object.values(error.response.data.errors).flat().join(' ')
		: error?.response?.data?.message || 'An unexpected error occurred'
	errorRef?.current?.open(errorMessages)
}
